var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// Mimic RNA-FISH's EditKitForm, as we have the same problems to solve here.
// Should be inside a `Form` whose `error` prop is set appropriately.
import * as React from "react";
import { Form, Grid, Header, Table } from "semantic-ui-react";
import ErrorDisplay from "../../ErrorDisplay";
import { Help } from "../../Help";
import { postJsonWithAuthn } from "../../RequestHelpers";
import { buildOnComponentStateChangeHandler } from "../FormState";
import { defaultAmpState, defaultSampleTypeState, discountMessage, priceColumn, PriceDisplay, ToggleableKitComponent } from "../rna-fish/EditKitForm";
import { HcrAmplifierForm } from "../rna-fish/HcrAmplifierForm";
import KitSerializer from "../rna-fish/KitSerializer";
import { ErrorElements } from "../rna-fish/NewRnaFishKitPage";
import SelectSampleTypeForm from "../rna-fish/SelectSampleTypeForm";
import BufferForm from "./BufferForm";
import { getIhc2AmplifierCatalog, getIhc2ProbeCatalog } from "./Ihc2Catalog";
import { serializeBuffers, serializeProbe } from "./KitSerialization";
import { defaultBuffersState, defaultProbeState } from "./NewIhc2KitPage";
import ProbeForm from "./ProbeForm";
var EditKitForm = /** @class */ (function (_super) {
    __extends(EditKitForm, _super);
    function EditKitForm(props) {
        var _this = _super.call(this, props) || this;
        // Doesn't handle setting the amplifier component's amplifier based on the probe amplifier, so this is wrapped
        _this.onProbeStateChangeBaseHandler = buildOnComponentStateChangeHandler(probeStateWrangler, _this.props.setFormState);
        _this.onAmpStateChange = buildOnComponentStateChangeHandler(ampStateWrangler, _this.props.setFormState);
        _this.onBufferStateChange = buildOnComponentStateChangeHandler(bufStateWrangler, _this.props.setFormState);
        _this.onSampleTypeStateChangeBaseHandler = buildOnComponentStateChangeHandler(sampleTypeStateWrangler, _this.props.setFormState);
        // Wrapper around normal state propagation to handle setting the amplifier component's amplifier
        _this.onProbeStateChange = function (probeState, prevAmplifier, callback) {
            return _this.onProbeStateChangeBaseHandler(probeState, function (newState) {
                var _a, _b;
                // TODO certain probe changes will always change the amplifier to the default amplifier. Use prevAmplifier
                // to make sure that the change to default only happens when we're changing the amplifier.
                var hcrAmplifier = (_a = newState.probeState.probeAmplifier) === null || _a === void 0 ? void 0 : _a.amplifier;
                var label = (_b = getIhc2AmplifierCatalog(_this.props.legacy, _this.props.catalog)
                    .channels.find(function (c) {
                    return c.hcrAmplifier.id === (hcrAmplifier === null || hcrAmplifier === void 0 ? void 0 : hcrAmplifier.id);
                })) === null || _b === void 0 ? void 0 : _b.defaultLabel.label;
                if (hcrAmplifier !== undefined && label !== undefined) {
                    _this.onAmpStateChange({
                        hcrAmplifier: hcrAmplifier,
                        label: label
                    }, callback);
                }
                else {
                    if (callback !== undefined) {
                        callback();
                    }
                }
            });
        };
        _this.onSampleTypeStateChange = function (sampleTypeFormState, _, callback) {
            return _this.onSampleTypeStateChangeBaseHandler(sampleTypeFormState, callback);
        };
        _this.onProbeEnableChange = function () {
            _this.props.setFormState(function (s) {
                return { probeEnabled: !s.probeEnabled };
            }, function (newState) {
                var _a;
                if (newState.probeEnabled) {
                    // trigger a state change so that the amplifier is overwritten
                    _this.onProbeStateChange({}, (_a = _this.props.formState.probeState.probeAmplifier) === null || _a === void 0 ? void 0 : _a.amplifier, _this.onUserSelection);
                }
                else {
                    _this.onUserSelection();
                }
            });
        };
        _this.onAmplifierEnableChange = function () {
            return _this.props.setFormState(function (s) { return ({ ampEnabled: !s.ampEnabled }); }, _this.onUserSelection);
        };
        _this.onBuffersEnableChange = function () {
            return _this.props.setFormState(function (s) { return ({ buffersEnabled: !s.buffersEnabled }); }, _this.onUserSelection);
        };
        _this.onCommentChange = function (event) {
            var str = event.currentTarget.value;
            _this.props.setFormState(function () {
                return {
                    comment: str
                };
            });
        };
        // The user finished editing something
        _this.onUserSelection = function () {
            _this.loadPrice();
        };
        // TODO dedup w/ rna-fish
        _this.loadPrice = function () {
            _this.props.setFormState(function () { return ({
                priceLoading: true
            }); }, function (newState) {
                postJsonWithAuthn(_this.props.kitPriceUrlPath, JSON.stringify(serializeIhc2Kit(newState)))
                    .then(function (resp) {
                    if (resp.status === 400) {
                        return resp.json().then(function (json) { return new ErrorElements(json.errors); });
                    }
                    return resp.json();
                }).then(function (resp) {
                    if (resp instanceof ErrorElements) {
                        _this.props.setFormState(function () { return ({
                            errors: resp.errors,
                            priceLoading: false,
                            price: undefined
                        }); });
                    }
                    else {
                        _this.props.setFormState(function () { return ({
                            errors: [],
                            price: resp,
                            priceLoading: false
                        }); });
                    }
                }).catch(function (rej) {
                    console.error("Couldn't update price: " + rej);
                });
            });
        };
        return _this;
    }
    EditKitForm.prototype.render = function () {
        return React.createElement("div", { className: 'kit-form' },
            React.createElement(ErrorDisplay, { errors: this.props.formState.errors, errorPath: "/" }),
            React.createElement("div", null),
            React.createElement(Header, { className: "component-slider" },
                React.createElement("span", { className: 'sample-type-span' }, "Sample type")),
            React.createElement("div", { className: 'no-outline-kit-component' },
                React.createElement(SelectSampleTypeForm, { sampleTypeState: this.props.formState.sampleTypeFormState, sampleTypes: this.props.catalog.buffer.sampleTypes, manualPro: false, onSampleTypeChange: this.onSampleTypeStateChange, onUserSelection: this.onUserSelection, errors: this.props.formState.errors, showErrors: this.props.showErrors })),
            React.createElement(ToggleableKitComponent, { componentEnabled: this.props.formState.probeEnabled, label: 'HCR™ Probe', otherComponentStates: [this.props.formState.ampEnabled, this.props.formState.buffersEnabled], onChange: this.onProbeEnableChange, cish: false },
                React.createElement(ProbeForm, { catalog: this.props.catalog, errors: this.props.formState.errors, priceCents: this.props.formState.price ? this.props.formState.price.kitPrice.probePriceCents : undefined, priceLoading: this.props.formState.priceLoading, probeState: this.props.formState.probeState, onProbeChange: this.onProbeStateChange, onUserSelection: this.onUserSelection, legacy: this.props.legacy, selectedSampleType: this.props.formState.sampleTypeFormState.sampleType, showErrors: this.props.showErrors })),
            React.createElement(ToggleableKitComponent, { componentEnabled: this.props.formState.ampEnabled, label: this.props.legacy ? 'HCR™ Amplifier (v3.0)' : 'HCR™ Gold Amplifier', otherComponentStates: [this.props.formState.probeEnabled, this.props.formState.buffersEnabled], onChange: this.onAmplifierEnableChange, cish: false },
                React.createElement(HcrAmplifierForm, { amplifierLabel: this.props.legacy ? EditKitForm.amplifierLabel : EditKitForm.goldAmplifierLabel, ampState: this.props.formState.ampState, catalog: getIhc2AmplifierCatalog(this.props.legacy, this.props.catalog), errors: this.props.formState.errors, hcrAmplifierDisabled: this.props.formState.probeEnabled, enableCustomPrice: false, enableCustomScale: false, onAmpStateChange: this.onAmpStateChange, selectedSampleType: this.props.formState.sampleTypeFormState.sampleType, onUserSelection: this.onUserSelection, priceCents: this.props.formState.price ? this.props.formState.price.kitPrice.amplifierPriceCents : undefined, priceLoading: this.props.formState.priceLoading, experimentVolumeTable: this.props.legacy ? ProbeForm.experimentVolumeTable : EditKitForm.goldExperimentTable, legacy: this.props.legacy, showErrors: this.props.showErrors })),
            React.createElement(ToggleableKitComponent, { componentEnabled: this.props.formState.buffersEnabled, label: 'HCR™ Buffers', otherComponentStates: [this.props.formState.probeEnabled, this.props.formState.ampEnabled], onChange: this.onBuffersEnableChange, cish: false },
                React.createElement(BufferForm, { bufferState: this.props.formState.buffersState, catalog: this.props.catalog.buffer, errors: this.props.formState.errors, onBufferChange: this.onBufferStateChange, onUserSelection: this.onUserSelection, priceLoading: this.props.formState.priceLoading, priceCents: this.props.formState.price ? this.props.formState.price.kitPrice.buffersPriceCents : undefined, enableCustomPrice: false, legacy: this.props.legacy, showErrors: this.props.showErrors })),
            React.createElement(ErrorDisplay, { errors: this.props.formState.errors, errorPath: "/" }),
            React.createElement(Grid, { columns: 4, stackable: true },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: 12, className: "no-left-padding-mobile" },
                        React.createElement(Form.Field, null,
                            React.createElement("label", { htmlFor: 'comment' }, "Comment"),
                            React.createElement(Form.TextArea, { style: { fontFamily: 'Avenir Next' }, placeholder: 'Please describe any instructions for order fulfillment or ' +
                                    'anything else the MI Team should be aware of regarding this order.', value: this.props.formState.comment, onChange: this.onCommentChange }))),
                    priceColumn(React.createElement("div", { 
                        // apply padding that matches the kit component div padding
                        style: { 'paddingRight': '.5rem' } },
                        React.createElement(PriceDisplay, { loading: this.props.formState.priceLoading, priceCents: this.props.formState.price ? this.props.formState.price.kitPrice.subtotalCents : undefined })))),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: 16 }, this.props.formState.price && discountMessage(this.props.formState.price.discountCents, this.props.formState.price.listPriceCents)))));
    };
    EditKitForm.prototype.componentDidMount = function () {
        if (this.props.loadPriceOnMount) {
            this.loadPrice();
        }
    };
    EditKitForm.amplifierLabel = React.createElement(React.Fragment, null,
        "Amplifier ",
        React.createElement(Help, null, "For multiplex experiments, choose a different HCR\u2122 Amplifier (v3.0) (B1, B2, ...) for each target that will be imaged in the same sample (for example, amplifier B1 for target 1, amplifier B2 for target 2, ...). Note that if your kit includes an HCR\u2122 Probe, the HCR\u2122 Amplifier (v3.0) in the kit is fixed by the specification of the probe above using the dropdown \u201CFor use with amplifier\u201D."));
    EditKitForm.goldAmplifierLabel = React.createElement(React.Fragment, null,
        "Amplifier ",
        React.createElement(Help, null,
            React.createElement("p", null, "For multiplex experiments, choose a different HCR\u2122 Gold Amplifier (X1, X2, \u2026) for each target that will be imaged in the same sample (for example, amplifier X1 for target 1, amplifier X2 for target 2, \u2026). Note that if your kit includes an HCR\u2122 Probe, the amplifier in the kit is fixed by the specification of the probe above using the dropdown \u201CFor use with amplifier\u201D."),
            React.createElement("p", null, "For flexibility, amplifiers X1, X2, and X3 are available with multiple label options (488, 546, 647), while for expanded multiplexing, amplifiers X4\u2013X10 are each available with one label option. We recommend using a longer-wavelength label (e.g., 647 or 750) for targets that are more difficult to detect (e.g., low-expression target and/or short target sequence), as autofluorescence tends to be higher in shorter-wavelength channels (e.g., 405 or 488).")));
    EditKitForm.goldExperimentTable = React.createElement(Table, { celled: true, striped: true },
        React.createElement(Table.Header, null,
            React.createElement(Table.Row, null,
                React.createElement(Table.HeaderCell, null, "Sample type"),
                React.createElement(Table.HeaderCell, null, "Reaction volume (\u00B5L)"),
                React.createElement(Table.HeaderCell, null, "HCR\u2122 Gold Amplifier (\u00B5L)"),
                React.createElement(Table.HeaderCell, null, "Experiments"))),
        React.createElement(Table.Body, null,
            React.createElement(Table.Row, null,
                React.createElement(Table.Cell, null, "Sample on a slide (e.g., tissue section or adherent cells)"),
                React.createElement(Table.Cell, null, "100"),
                React.createElement(Table.Cell, null, "2"),
                React.createElement(Table.Cell, null, "100")),
            React.createElement(Table.Row, null,
                React.createElement(Table.Cell, null, "Sample in solution (e.g., whole-mount embryo or cells in suspension)"),
                React.createElement(Table.Cell, null, "500"),
                React.createElement(Table.Cell, null, "10"),
                React.createElement(Table.Cell, null, "20"))));
    return EditKitForm;
}(React.PureComponent));
export { EditKitForm };
export var defaultIhc2FormState = function (catalog, legacy) { return ({
    ampEnabled: true,
    ampState: defaultAmpState(getIhc2AmplifierCatalog(legacy, catalog)),
    buffersEnabled: true,
    buffersState: defaultBuffersState(catalog, legacy),
    comment: '',
    errors: [],
    probeEnabled: true,
    probeState: defaultProbeState(getIhc2ProbeCatalog(legacy, catalog)),
    sampleTypeFormState: defaultSampleTypeState(),
    priceLoading: false,
    legacy: legacy
}); };
// TODO tests for serialization
export var serializeIhc2Kit = function (state) {
    var kit = {
        comment: state.comment,
    };
    if (state.probeEnabled) {
        kit.probeComponent = serializeProbe(state.probeState);
    }
    if (state.ampEnabled) {
        // re-use the rna-fish serialization since it's the same component
        kit.amplifierComponent = KitSerializer.serializeAmplifier(state.ampState);
    }
    if (state.buffersEnabled) {
        kit.buffersComponent = serializeBuffers(state.buffersState, state.legacy);
    }
    kit.legacy = state.legacy;
    kit.sampleTypeId = state.sampleTypeFormState.sampleType.id;
    return {
        '_type': '2-ihc',
        kit: kit
    };
};
var ProbeStateWrangler = /** @class */ (function () {
    function ProbeStateWrangler() {
        this.buildHolderFromComponentState = function (componentFormState) { return ({ probeState: componentFormState }); };
        this.extractComponentState = function (holder) { return holder.probeState; };
    }
    return ProbeStateWrangler;
}());
var AmpStateWrangler = /** @class */ (function () {
    function AmpStateWrangler() {
        this.buildHolderFromComponentState = function (componentFormState) { return ({ ampState: componentFormState }); };
        this.extractComponentState = function (holder) { return holder.ampState; };
    }
    return AmpStateWrangler;
}());
var BufferStateWrangler = /** @class */ (function () {
    function BufferStateWrangler() {
        this.buildHolderFromComponentState = function (componentFormState) { return ({ buffersState: componentFormState }); };
        this.extractComponentState = function (holder) { return holder.buffersState; };
    }
    return BufferStateWrangler;
}());
var SampleTypeStateWrangler = /** @class */ (function () {
    function SampleTypeStateWrangler() {
        this.buildHolderFromComponentState = function (componentFormState) { return ({ sampleTypeFormState: componentFormState }); };
        this.extractComponentState = function (holder) { return holder.sampleTypeFormState; };
    }
    return SampleTypeStateWrangler;
}());
var probeStateWrangler = new ProbeStateWrangler();
var ampStateWrangler = new AmpStateWrangler();
var bufStateWrangler = new BufferStateWrangler();
var sampleTypeStateWrangler = new SampleTypeStateWrangler();
//# sourceMappingURL=EditKitForm.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/ihc2/EditKitForm.js
// module id = 91
// module chunks = 0